import { QueryBuilderModel } from 'vet-bones/components';

import { SEARCH_TYPE_RELATIONSHIP } from 'src/containers/ProjectRuleDetailDrawer/constants';
import { RDF_TYPE_IRI } from 'src/templates/queries/iris';

export const getValidThenModel = (
  validIfModel: QueryBuilderModel
): QueryBuilderModel => ({
  ...validIfModel,
  propertiesByIri: {
    ...validIfModel.propertiesByIri,
    [RDF_TYPE_IRI]: SEARCH_TYPE_RELATIONSHIP,
  },
});
